import { createFileRoute, redirect } from "@tanstack/react-router"

import { DebtNotes } from "@/components/debt-table/DebtNotes"
import { DebtTable } from "@/components/debt-table/DebtTable"

export const Route = createFileRoute("/_dashboard/_customer/debt-table")({
  component: DebtTableView,
  beforeLoad: ({ context: { store, hasPermissions } }) => {
    if (
      !hasPermissions([
        "analytics.view_debtschedule",
        "analytics.view_debtschedulenotes",
      ])
    ) {
      throw redirect({ to: "/" })
    }
    const companyUuid = store.getState().activeCompanyUuid
    if (!companyUuid) {
      throw redirect({ to: "/home" })
    }
    return { companyUuid }
  },
})

export function DebtTableView() {
  const { companyUuid } = Route.useRouteContext()
  return (
    <>
      <div className="flex min-w-0 flex-col rounded-lg bg-white p-6 text-sm shadow-sm">
        <DebtTable companyUuid={companyUuid} />
      </div>
      <div className="mt-5 flex min-w-0 flex-col rounded-lg bg-white p-6 text-sm shadow-sm">
        <DebtNotes companyUuid={companyUuid} />
      </div>
    </>
  )
}
